import { Pipe, PipeTransform } from '@angular/core';
import { SettingsService } from '@app/_services/settings.service';

@Pipe({
    name: 'parseBytes',
    pure: true,
    standalone: true,
})

export class ParseBytesPipe implements PipeTransform {

    constructor(public ss: SettingsService) { }

    transform(value: number | string | null | undefined, unitFrom: 'B' | 'KB' = 'B', useSI = false): string {
        if (value === null || value === undefined || value === '') {
            return this.ss.t('account_mediaStorageStatusKBused', { storageUsed: '0' });
        }

        const kb = typeof value === 'string' ? parseFloat(value) : Number(value);
        if (!isFinite(kb) || isNaN(kb)) {
            return this.ss.t('account_mediaStorageStatusKBused', { storageUsed: '0' });
        }

        let unit = 'KB';
        let val = kb;

        if (val >= 1024) {
            val /= 1024;
            unit = 'MB';
        }
        if (val >= 1024) {
            val /= 1024;
            unit = 'GB';
        }

        const final = Math.round(val).toString();

        switch (unit) {
            case 'KB':
                return this.ss.t('account_mediaStorageStatusKBused', { storageUsed: final });
            case 'MB':
                return this.ss.t('account_mediaStorageStatusMBused', { storageUsed: final });
            case 'GB':
                return this.ss.t('account_mediaStorageStatusGBused', { storageUsed: final });
            default:
                return this.ss.t('account_mediaStorageStatusKBused', { storageUsed: '0' });
        }
    }
}